module.exports = "https://cdn.thelire.com/ins/resource/pic_coinstore_vippackages1@3x.d38bc4088d1815c34c2e892a0e328e8a.png";